// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { AdresGetAdresParams } from '../model/adresGetAdresParams.ts';

import type { Result1OfCrmAdressenZoekEnMaakAdresAdresMetToevoegingen } from '../model/result1OfCrmAdressenZoekEnMaakAdresAdresMetToevoegingen.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const adresGetAdres = (
  params?: MaybeRefOrGetter<AdresGetAdresParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<Result1OfCrmAdressenZoekEnMaakAdresAdresMetToevoegingen>(
    { url: `/api/v1/adres`, method: 'GET', params, signal },
    options,
  );
};

export const getAdresGetAdresQueryKey = (params?: MaybeRefOrGetter<AdresGetAdresParams>) => {
  return ['api', 'v1', 'adres', ...(params ? [params] : [])] as const;
};

export const getAdresGetAdresQueryOptions = <
  TData = Awaited<ReturnType<typeof adresGetAdres>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<AdresGetAdresParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adresGetAdres>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getAdresGetAdresQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adresGetAdres>>> = ({ signal }) =>
    adresGetAdres(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adresGetAdres>>,
    TError,
    TData
  >;
};

export type AdresGetAdresQueryResult = NonNullable<Awaited<ReturnType<typeof adresGetAdres>>>;
export type AdresGetAdresQueryError = ErrorType<void>;

export function useAdresGetAdres<
  TData = Awaited<ReturnType<typeof adresGetAdres>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<AdresGetAdresParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adresGetAdres>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdresGetAdresQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
